import { AnyAction } from 'redux';
import { App, VhvV2Vorbelegungdaten } from '@ps20-frontend/frontend-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';
import {
  clampEntschaedigungsgrenze,
  EntschaedigungsgrenzeRadForLinie,
} from '../model/entschaedigungsgrenzeRad.model';
import { isFahrradBaustein } from '../model/fahradwertForLinie.model';

export const entschaedigungsgrenzeRadReducer = function (
  sectionState: Array<EntschaedigungsgrenzeRadForLinie> = [],
  action: AnyAction,
  state: IAppState,
): Array<EntschaedigungsgrenzeRadForLinie> {
  switch (action.type) {
    case VhvActions.ENTSCHAEDIGUNGSGRENZE_RAD_RECEIVED: {
      const relevantVorbelegungdaten = state.transientState?.relevantVorbelegungdaten;
      const vorbelegungFehler = relevantVorbelegungdaten?.fahrradVorbelegungFehler;
      const fahrradBaustein = relevantVorbelegungdaten?.vorvertragBausteinList?.find(isFahrradBaustein);
      if (vorbelegungFehler == null && fahrradBaustein?.betrag == null) {
        return action.payload.entschaedigungsgrenzen;
      }
      return action.payload.entschaedigungsgrenzen.map(
        (linie: EntschaedigungsgrenzeRadForLinie) => {
          if (!linie.available) {
            return linie;
          }
          return {
            ...linie,
            ...(fahrradBaustein?.betrag != null ? { betrag: fahrradBaustein.betrag } : {}),
            ...(vorbelegungFehler != null ? { vorbelegungFehler } : {}),
          };
        },
      );
    }
    case VhvActions.ENTSCHAEDIGUNGSGRENZE_RAD_CHANGED: {
      return sectionState.map((linie): EntschaedigungsgrenzeRadForLinie => ({
        ...linie,
        betrag: clampEntschaedigungsgrenze(action.payload.betrag, linie.minInput, linie.maxInput),
        vorbelegungFehler: null,
      }));
    }
    case VhvActions.PRODUKT_ZUSATZOPTIONEN_VORBELEGT: {
      const vorbelegungdaten: VhvV2Vorbelegungdaten = action.payload;
      const fahrradBaustein = vorbelegungdaten?.vorvertragBausteinList?.find(isFahrradBaustein);
      if (fahrradBaustein == null) {
        return sectionState;
      }
      return sectionState.map((linie): EntschaedigungsgrenzeRadForLinie => {
        if (!linie.available) {
          return linie;
        }
        return {
          ...linie,
          ...(fahrradBaustein.betrag != null ? { betrag: fahrradBaustein.betrag } : {}),
          vorbelegungFehler: fahrradBaustein.hinweis ?? null,
        };
      });
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const vorbelegungdaten: VhvV2Vorbelegungdaten = action.payload;
      if (vorbelegungdaten.forApp !== App.VHV_V2 || vorbelegungdaten.angebotsId !== state.angebotsId) {
        return sectionState;
      }
      const fahrradBaustein = vorbelegungdaten.vorvertragBausteinList?.find(isFahrradBaustein);
      if (fahrradBaustein == null) {
        return sectionState;
      }
      if (sectionState.length === 0) {
        return [
          {
            produktlinie: vorbelegungdaten.produktlinienname,
            betrag: fahrradBaustein.betrag ?? null,
            defaultwert: fahrradBaustein.betrag ?? null,
            minInput: null,
            maxInput: null,
            schrittweite: null,
            available: true,
            vorbelegungFehler: fahrradBaustein.hinweis ?? null,
          },
        ];
      }
      return sectionState.map((linie): EntschaedigungsgrenzeRadForLinie => {
        if (!linie.available) {
          return linie;
        }
        return {
          ...linie,
          ...(fahrradBaustein.betrag != null ? { betrag: fahrradBaustein.betrag } : {}),
          vorbelegungFehler: fahrradBaustein.hinweis ?? null,
        };
      });
    }
    default:
      return sectionState;
  }
};
